"use client"

import { Trans } from "@lingui/react/macro"
import { cn } from "@rarible_int/anaconda_ui_components"

export const SITE_DISCLAIMER_TEXT =
  "The Platform may display references to third-party brands, trademarks, trade names, logos, characters, artwork, product names, and other intellectual property solely for purposes of identifying, describing, categorizing, indexing, searching for, discovering, or facilitating user-generated content and marketplace activity. All such intellectual property is the property of its respective owner. Rarible does not own nor claim any rights in such intellectual property, and the display of any such materials does not imply any affiliation, sponsorship, endorsement, authorization, or approval by the applicable rights holder."

type SiteDisclaimerProps = {
  className?: string
}

export function SiteDisclaimer({ className }: SiteDisclaimerProps) {
  return (
    <p
      className={cn("text-3xs leading-relaxed text-foreground/50", className)}
      data-testid="site-disclaimer"
    >
      <Trans>{SITE_DISCLAIMER_TEXT}</Trans>
    </p>
  )
}
